import React from "react";
import Banner from "../../Common/Banner/Banner";

import { getContent } from "../CMS/CMSFunctions";

const WelcomeCard = ({ appCode = null, organisation = null }) => {
    const cmsContent = getContent(appCode, organisation);

    return (
        <Banner
            image={cmsContent.image}
            title={cmsContent.title}
            body={cmsContent.body}
        />
    );
};

export default WelcomeCard;
